import { tsValidateArray, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_Orders, smartDocStaticParamType_Orders_Statuses, smartDocStaticParamType_Orders_SubTypes } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParamResolver_Orders } from '../../../smart-doc-param-resolver/index.js';
import { ResourceTypes } from '@app/hcs-shared';
export const Validator_SmartDocStaticParam_Orders = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_Orders]),
    orderSubtype: tsValidateArray(tsValidateValue([...smartDocStaticParamType_Orders_SubTypes])),
    orderStatus: tsValidateArray(tsValidateValue([...smartDocStaticParamType_Orders_Statuses])),
    relatedResource: tsValidateArray(tsValidateValue([...ResourceTypes])),
    resolver: Validator_SmartDocParamResolver_Orders,
};
//# sourceMappingURL=validator.js.map